export default "__VITE_ASSET__CERIDOWQ__"